import ApiKeys from './apiKeys.json'

type Env = 'dev' | 'prod' | 'staging'

export const env = ApiKeys.env as Env

export function whenEnv<T>(check: Env, value: T): T | undefined {
	if (env === check) {
		return value
	}
	return undefined
}
export function whenEnvNot<T>(check: Env, value: T): T | undefined {
	if (env !== check) {
		return value
	}
	return undefined
}
